module.exports = __webpack_public_path__ + "static/media/sd_mesa_college_logo.8bfbf7c5.jpg";